<template lang="pug">
  .crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addRecord, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
    modal-import(model="purchase_orders")
    modal-purchase-orders(:form='form', :is-add='isModalAdd')
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.purchase_orders') }}:
            span {{ $t('strings.description', {attribute: $t('strings.purchase_orders')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-button(icon="plus" @click="addRecord") {{ $t('strings.add') }}
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="exportPurchaseOrders")
                    vm-icon(icon="download-outline")
                    slot &nbsp;{{ $t('strings.export') }}
                  //- More options
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(multiple v-model="selected"  max-height="350px" :data="purchaseOrders" )
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(ref="search" icon="search" size="small" v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="300px")
                .d-flex.justify-content-between(@click="loadCatalogsFilters()")
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")

                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                        vm-date-picker.filter(type="daterange" :label="$t('purchase_orders.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                        vm-select.filter(:placeholder='$t("strings.multiple")' :label='$t("shipments.status_id")' multiple autocomplete v-model="filters.whereIn.status_id" @change="$emit('filter', filters)")
                          vm-select-item(:key='index', :value='item.id', :text="$t('purchase_orders.'+ item.id)", v-for='item,index in purchaseOrderStatuses')
                        vm-select.filter(:placeholder='$t("strings.multiple")' :label='$t("purchase_orders.balance_status_id")' multiple autocomplete v-model="filters.whereIn.balance_status_id" @change="$emit('filter', filters)")
                          vm-select-item(:key='index', :value='item.id', :text="$t('purchase_order_balance_status.'+ item.id)", v-for='item,index in purchaseOrderBalanceStatuses')
                        //- Add filters
                            Agrega los filtros que prefieras por ejemplo:
                            vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                              vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")

                            NOTA: (agregar clase .filter)
                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                  vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('purchase_orders.'+ item)")
                    vm-order-by-item(value='folio,asc' text='Folio' direction='down')
                    vm-order-by-item(value='folio,desc' text='Folio' direction='up')
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list" style="display: none;")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('purchase_orders.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  .details(@click="goDetail(data[indextr])")
                    slot(v-if="column == 'total' || column == 'subtotal'")  {{data[indextr][column] | currency()}}
                    slot(v-if="column == 'exchange_rate'") {{data[indextr][column] | currency}}
                    slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                    slot(v-if="column == 'supplier_display' && $auth.check(['Admin', 'Agente Aduanal'])") {{data[indextr]['supplier_display'] }}
                    slot(v-if="column != 'status_id' && column !== 'balance_status_id' && column != 'created_at' && column != 'name' && column != 'supplier_display' && column != 'total' && column != 'subtotal' && column != 'exchange_rate'") {{data[indextr][column]}}
                    vm-status-indicator(v-if="column == 'status_id'" :pulse="!!data[indextr]['status_id']" :color="colorStatus(data[indextr]['status_id'])") {{ $t('purchase_orders.'+ data[indextr]['status_id']) }}
                    vm-status-indicator(v-if="column == 'balance_status_id'" :pulse="!!data[indextr]['balance_status_id']" :color="colorBalanceStatus(data[indextr]['balance_status_id'])") {{ $t('purchase_order_balance_status.'+ data[indextr]['balance_status_id']) }}
                vm-td
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                  vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="editRecord(data[indextr], tr)")
                      vm-icon(icon="edit-2-outline")
                      slot &nbsp;{{ $t('strings.edit') }}
                    vm-dropdown-item.d-flex.justify-content-between(v-if="!tr.has_shipped_products" @click="goExcel(data[indextr], tr)")
                      vm-icon(icon="edit-2-outline")
                      slot &nbsp;{{ $t('purchase_orders.add_with_excel') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="printReport(data[indextr], tr)")
                      vm-icon(icon="printer-outline")
                      slot &nbsp;{{ $t('strings.print') }}
                    vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status_id'] != 4" @click="setActionRecord(data[indextr], 'approve')")
                      vm-icon(icon="checkmark-circle-outline")
                      slot &nbsp;{{ $t('purchase_orders.approve_order') }}
                    vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status_id'] != 2" @click="disapproveOrder(data[indextr])")
                      vm-icon(icon="close-outline")
                      slot &nbsp;{{ $t('purchase_orders.disapprove_order') }}
                    vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin') && data[indextr]['status_id'] === 2 || data[indextr]['status_id'] === 4" @click="cancelPurchaseOrder(data[indextr])")
                      vm-icon(icon="slash-outline")
                      slot &nbsp;{{ $t('strings.cancel') }}
                    vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] === 'Inactivo'" @click="deleteRecordConfirm(data[indextr])")
                      vm-icon(icon="trash-2-outline")
                      slot &nbsp;{{ $t('strings.delete') }}
                    //- More actions
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers, mapGetters as configMapGetters } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrders')
const ModalImport = () => import('@/components/modals/ModalImport.vue')
const ModalPurchaseOrders = () => import('@/components/modals/ModalPurchaseOrders.vue')

export default {
  name: 'ViewPurchaseOrders',
  components: {
    ModalImport,
    ModalPurchaseOrders
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    cachingFilters: true,
    cacheKey: 'user_oc_filters',
    columns: [
      'folio',
      'manual_folio',
      'supplier_display',
      'total',
      'subtotal',
      'currency_display',
      'exchange_rate',
      'notes',
      'status_id',
      'balance_status_id',
      'created_at'
    ],
    columnsOrderBy: ['name', 'email'],
    attributeModal: 'manual_folio',
    status: [
      {
        value: 1,
        color: 'success'
      },
      {
        value: 2,
        color: 'warning'
      },
      {
        value: 3,
        color: 'danger'
      },
      {
        value: 4,
        color: 'primary'
      }
    ],
    balanceStatus: [
      {
        value: 1,
        color: 'warning'
      },
      {
        value: 2,
        color: 'danger'
      },
      {
        value: 3,
        color: 'success'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        manual_folio: '',
        folio: '',
        supplier: {
          business_name: ''
        },
        total: '',
        subtotal: '',
        currency: {
          name: ''
        },
        exchange_rate: '',
        branch_id: '',
        param: ''
      },
      whereIn: {
        status_id: [],
        balance_status_id: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  created () {
    if (!this.isSFS) this.columns.splice(10, 0, 'branch_display')
  },
  computed: {
    ...mapGetters([
      'purchaseOrders',
      'purchaseOrderStatuses',
      'purchaseOrderBalanceStatuses',
      'pagination',
      'filterParams'
    ]),
    ...configMapGetters(['isSFS', 'isHMM'])
  },
  methods: {
    ...mapActions([
      'setIsAdd',
      'updateRecord',
      'deleteRecord',
      'deleteRecords',
      'loadRecords',
      'getPurchaseOrderStatuses',
      'getPurchaseOrderBalancesStatuses',
      'actionRecord',
      'setModalVisible',
      'setModalImportVisible',
      'exportRecords',
      'applyFilter',
      'clearFilter',
      'print',
      'hasNonCancelledShipments'
    ]),
    colorBalanceStatus (code) {
      return this.balanceStatus.find(e => e.value === code)['color']
    },
    async disapproveOrder (record) {
      this.hasNonCancelledShipments(record).then((response) => {
        if (response) {
          this.setActionRecord(record, 'pending')
        }
      })
    },
    async cancelPurchaseOrder (record) {
      this.auxCreateRecord = () => {
        this.hasNonCancelledShipments(record).then((response) => {
          if (response) {
            this.setActionRecord(record, 'cancel')
          }
        })
      }
      this.$vm.dialog({
        color: 'primary',
        title: this.$t('purchase_orders.cancel_confirmation_title'),
        text: this.$t('purchase_orders.cancel_confirmation_text') + ' ' + record.manual_folio,
        accept: this.auxCreateRecord,
        acceptText: this.$t('strings.accept')
      })
    },
    printReport (record) {
      if (this.$auth.check('Admin') || this.$auth.check('Agente Aduanal')) {
        this.print(record)
      }
    },
    goDetail (record) {
      this.$router.push(`/purchase_order/${record.id}/detail`)
    },
    goExcel (record) {
      this.$router.push({ name: 'tab-purchase-order', params: { id: record.id } })
    },
    exportPurchaseOrders () {
      this.exportByBranch(this.filters)
    },
    async loadCatalogsFilters () {
      if (this.purchaseOrderStatuses.length === 0) await this.getPurchaseOrderStatuses()
      if (this.purchaseOrderBalanceStatuses.length === 0) await this.getPurchaseOrderBalancesStatuses()
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
